<template>
  <div class="page-container">
    <div class="page-content">
      
      <!-- Page Header -->
      <div class="page-header">
        <div class="row space-around mb-3 d-flex">
          <div class="col-10">
            <h1 class="text-white">
              <i class="mdi mdi-hubspot"></i> Hubspot
            </h1>
          </div>
        </div>
      </div>
      
      <!-- Corpo da página -->
      <div class="page-body">
        <!-- Container do card e tabela estilo PHP -->
        <div class="card">
          <div class="card-body">
            
            <div class="row">

              <div class="col-md-4 formulario mb-5">

                <h6 class="form-subheader mb-4"><span>Buscar no Hubspot</span></h6>
                
                <b-alert show :variant="'warning'" v-if="alertMessage" class="mb-3">{{ alertMessage }}</b-alert>
                
                <div class="row">

                  <div class="col-12">
                    <div class="form-group">
                      <label for="acrisureNumber" class="dbo-ui">CNPJ Cliente</label>                        
                      <b-form-input v-model="cnpjSearch" @change="onChangeCompanyCnpj"
                        v-mask="'XX.XXX.XXX/XXXX-##'">
                      </b-form-input>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label for="acrisureNumber" class="dbo-ui">Nome Cliente</label>                        
                      <b-form-input v-model="nameSearch">
                      </b-form-input>
                    </div>
                  </div>

                  <div class="col-12 align-self-end text-right">
                    <b-button class="ml-auto" variant="primary" type="submit" @click="searchHubspot()">
                      <span v-if="importLoading">
                        <i class="fa fa-spinner fa-spin mr-1"></i> 
                        Processando...
                      </span>
                      <span v-else>
                        Buscar
                      </span>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-md-7 offset-md-1 lista-empresas" v-if="resultCompanies.length > 0">

                <div class="row mb-5" v-for="resultCompany in resultCompanies" :key="resultCompany.cnpj">
                  <div class="col-12">
                      <h6 class="form-subheader mb-3"><span>Dados da Empresa</span></h6>

                      <div class="row mb-2">
                          <div class="col-md-4">
                              <label class="dbo-ui" for="company_cnpj">CNPJ</label>
                              <p>{{ resultCompany.cnpj | formatDocument }}</p>
                          </div>

                          <div class="col-md-8">
                              <label class="dbo-ui" for="company_name">Nome da empresa</label>
                              <p>{{ resultCompany.name }}</p>
                          </div>
                      </div>
                      <div class="row mb-2">
                          <div class="col-md-4">
                              <label class="dbo-ui" for="company_name">Proprietário da empresa</label>
                              <p>{{ resultCompany.proprietario }}</p>
                          </div>
                          <div class="col-md-4">
                              <label class="dbo-ui" for="company_name">Responsável SDR</label>
                              <p>{{ resultCompany.responsavel_sdr }}</p>
                          </div>
                      </div>

                      <div class="row mb-2">
                          <div class="col-md-4">
                              <label class="dbo-ui" for="company_name">Status da empresa</label>
                              <p>{{ resultCompany.status_da_empresa }}</p>
                          </div>
                          <div class="col-md-4">
                              <label class="dbo-ui" for="company_name">Criado em</label>
                              <p>{{ formatDateTimeFromISO(resultCompany.createdAt) }}</p>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-md-12 mt-3">
                            <a :href="resultCompany.url" class="btn btn-secondary" target="_blank">Abrir empresa no Hubspot</a>
                          </div>
                      </div>
                  </div>
                </div>

                
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
  
</template>

<script>
import { mask } from "vue-the-mask";
import dateFormatter from "@/mixins/dateFormatter";
import hubspotService from "@/services/hubspot";

export default {
  name: "hubspot-search",
  components: { },
  mixins: [dateFormatter],
  directives: { mask, },
  data: () => ({
    importLoading: false,
    cnpjSearch: '',
    nameSearch: '',
    itemsEconomicGroup: [],
    resultCompanies: []
  }),
  created() { },
  methods: {
    searchHubspot() {
      this.resetAlert();
      if (!this.cnpjSearch && !this.nameSearch) {
        this.showError("Preencher pelo menos 1 campo.");
        return false;
      }

      this.importLoading = true;
      this.resultCompanies = [];

      hubspotService.get({
          'document' : this.cnpjSearch,
          'name' : this.nameSearch
        })
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }

          this.resultCompanies = response.data;
        })
        .catch((error) => {
          this.showError(error.response.data.error ?? "Não foi possível buscar informações.");
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
    onChangeCompanyCnpj(cnpj) {
      if (cnpj.length != 18) {
        this.cnpjSearch = '';
      }
    },
  },
};
</script>

<style scoped>
.lista-empresas { max-height: 600px; overflow-y: auto; margin-bottom: 20px; }
</style>
